// @flow

import React from 'react';
import smartTruncate from 'app/common/lib/util/smartTruncate';
import Text from 'app/common/react/components/common/ExperimentalLegoGestalt/Text';

type Props = {|
  isBold?: boolean,
  isHorizontalDesign: boolean,
  numLines: number,
  singleLineMaxCharacters: number,
  text: string,
|};

export default function AvatarHoverCardTruncatedText({
  text,
  singleLineMaxCharacters,
  isBold,
  isHorizontalDesign,
  numLines,
}: Props) {
  const maxLength = numLines * singleLineMaxCharacters;
  const truncatedText = smartTruncate(text, maxLength);

  if (isBold) {
    return (
      <Text
        align={isHorizontalDesign ? 'left' : 'center'}
        overflow="normal"
        size="sm"
        weight="semibold"
      >
        {truncatedText}
      </Text>
    );
  }
  return (
    <Text
      align={isHorizontalDesign ? 'left' : 'center'}
      overflow="normal"
      size="sm"
      weight="normal"
      color={isHorizontalDesign ? 'darkGray' : 'gray'}
    >
      {truncatedText}
    </Text>
  );
}
